import React from 'react';
import {Typography, useTheme} from '@mui/material';

import Icon from 'presentation/icons';

import type {DetailsDrawerInfoItemProps} from '../../types';
import {InfoListItem, InfoListItemIconStack, InfoListItemText} from './styles';

function DetailsDrawerInfoItem({iconName, primary, secondary}: DetailsDrawerInfoItemProps) {
	const {palette} = useTheme();

	return (
		<InfoListItem disablePadding>
			<InfoListItemIconStack>
				<Icon name={iconName} color={palette.primary.main} size={20} />
			</InfoListItemIconStack>
			<InfoListItemText
				primary={
					<Typography variant="body2" color={palette.text.secondary} fontWeight={400}>
						{primary}
					</Typography>
				}
				secondary={
					<Typography variant="body1" fontWeight={400}>
						{secondary}
					</Typography>
				}
			/>
		</InfoListItem>
	);
}

export {DetailsDrawerInfoItem};
